export const GoogleOAuthClientID =
  '541066827089-hm3v9dmihpjlk4k1pdk144ef4iubf79k.apps.googleusercontent.com';
